import { Typography } from 'components'

import { Stepper } from '../../../components/Stepper'

type Props = {
	title: string
	subtitle: string
	steps: {
		number: number
		completed: boolean
		current: boolean
	}[]
}

const TeamFormHeader = ({ title, subtitle, steps }: Props) => (
	<div className='flex grid-cols-1 flex-col-reverse gap-10 xl:grid xl:grid-cols-[2fr_1fr]'>
		<div>
			<Typography color='text-black-100' text={title} variant='h3' />
			<Typography
				class='mt-2'
				color='text-black-200'
				text={subtitle}
				variant='text1'
			/>
		</div>
		<Stepper steps={steps} />
	</div>
)

export { TeamFormHeader }
